export default class CartItem {
    constructor(dom) {
        this.dom = dom;
    }

    init() {
       let qtyBtns = this.dom.querySelectorAll('.qty-btn');
       for( let qtyBtn of qtyBtns){
            // console.log(qtyBtn);
            qtyBtn.removeEventListener('click', this.handle, true);
            qtyBtn.addEventListener('click', this.handle, true);
        }
    }

    handle(e) {
      e.preventDefault();
      let qtyInput = e.target.closest('.qty').querySelector('input.qty-input');
      if(e.target.classList.contains('qty-minus')){
          if(qtyInput.value>1){
              qtyInput.value--;
              qtyInput.dispatchEvent(new Event('change'));
          }
      }else{

          qtyInput.value++;
          qtyInput.dispatchEvent(new Event('change'));
      }
    }
}
